import { render, staticRenderFns } from "./amazonProductTextOnly.vue?vue&type=template&id=e2293902&scoped=true"
import script from "./amazonProductTextOnly.vue?vue&type=script&lang=js"
export * from "./amazonProductTextOnly.vue?vue&type=script&lang=js"
import style0 from "./amazonProductTextOnly.vue?vue&type=style&index=0&id=e2293902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2293902",
  null
  
)

export default component.exports